import InvoiceHeader from "./components/InvoiceHeader";
import SellerCard from "./components/SellerCard";
import CustomerCard from "./components/CustomerCard";
import ProductTable from "./components/ProductTable";
import InvoiceSummary from "./components/InvoiceSummary";
import PaymentInfo from "./components/PaymentInfo";
import FooterCard from "./components/FooterCard";
import styles from "./components/styles";
import {  Document, Page, View,} from "@react-pdf/renderer";

export default function InvoicePDF({ order }) {
  const products = order.products || [];

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.invoice}>

          <InvoiceHeader order={order} />

          <View style={styles.infoRow}>
            <SellerCard />
            <CustomerCard order={order} />
          </View>

          <ProductTable products={products} />

          <View style={styles.footerRow}>
            <InvoiceSummary order={order} />
            <PaymentInfo order={order} />
          </View>
          <FooterCard />
        </View>
      </Page>
    </Document>
  );
}

